import { useCallback, useEffect, useState } from 'react';
import { fetchFeatureFlagsFromDb } from '../api/featureFlagsApi';
import { buildDefaultFlagMap } from '../lib/featureFlags';

/**
 * Loads `feature_flags` from Supabase (falls back to code defaults).
 */
export function useFeatureFlags() {
  const [map, setMap] = useState(() => buildDefaultFlagMap());
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const next = await fetchFeatureFlagsFromDb();
      setMap(next);
    } catch {
      setMap(buildDefaultFlagMap());
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  useEffect(() => {
    function onAdminRefresh() {
      void refresh();
    }
    window.addEventListener('mingo-feature-flags-refresh', onAdminRefresh);
    return () => window.removeEventListener('mingo-feature-flags-refresh', onAdminRefresh);
  }, [refresh]);

  useEffect(() => {
    function onVis() {
      if (document.visibilityState === 'visible') void refresh();
    }
    window.addEventListener('focus', refresh);
    document.addEventListener('visibilitychange', onVis);
    const id = window.setInterval(() => void refresh(), 120_000);
    return () => {
      window.removeEventListener('focus', refresh);
      document.removeEventListener('visibilitychange', onVis);
      window.clearInterval(id);
    };
  }, [refresh]);

  return { featureFlagMap: map, setFeatureFlagMap: setMap, refreshFeatureFlags: refresh, featureFlagsLoading: loading };
}
